export const SliderData = [
  {
    image: require("../images/sliderimage1.jpg"),
    description: "NEW ARRIVALS",
    link: "/shop",
  },
  {
    image: require("../images/sliderimage2.jpg"),
    description: "OUR MISSION",
    link: "/about",
  },
  {
    image: require("../images/sliderimage3.jpg"),
    description: "SHOP NOW",
    link: "/shop",
  },
  {
    image: require("../images/sliderimage4.jpg"),
    description: "MEET THE TEAM",
    link: "/team",
  },
  {
    image: require("../images/sliderimage5.jpg"),
    description: "CONTACT US",
    link: "mailto:shopspero@gmail.com",
  },
];
